export const SHOP_PRODUCTS = [
  {
    id: 'hat-47',
    name: "300 NEW ERA ’47",
    priceCents: 8999,
    currency: 'CAD',
    description: '',
    details: [
      ['Fabric type', '100% cotton'],
      ['Closure type', 'Buckle'],
      ['Fit type', 'Adjustable'],
    ],
    variants: [
      { id: 'black', name: 'Black', image: '/shop/products/47/47-4.png' },
      { id: 'blue', name: 'Blue', image: '/shop/products/47/47-5.png' },
      { id: 'charcoal', name: 'Charcoal', image: '/shop/products/47/47-3.png' },
      { id: 'dune', name: 'Dune', image: '/shop/products/47/47-2.png' },
    ],
    images: [
      '/shop/products/47/47-2.png',
      '/shop/products/47/47-3.png',
      '/shop/products/47/47-4.png',
      '/shop/products/47/47-5.png',
    ],
  },
  {
    id: 'hat-9fifty',
    name: '300 NEW ERA 9FIFTY',
    priceCents: 9999,
    currency: 'CAD',
    description: '',
    details: [
      ['Fabric type', '100% Polyester, Woven'],
      ['Closure type', 'Snap'],
    ],
    variants: [
      { id: 'black-grey-uv', name: 'Black/Grey Uv', image: '/shop/products/9fifty/9fifty-1.png' },
      { id: 'blue', name: 'Blue', image: '/shop/products/9fifty/9fifty-2.png' },
      { id: 'dark-green', name: 'Dark Green', image: '/shop/products/9fifty/9fifty-3.png' },
      { id: 'graphite', name: 'Graphite', image: '/shop/products/9fifty/9fifty-4.png' },
      { id: 'woodland', name: 'Woodland', image: '/shop/products/9fifty/9fifty-5.png' },
    ],
    images: [
      '/shop/products/9fifty/9fifty-1.png',
      '/shop/products/9fifty/9fifty-2.png',
      '/shop/products/9fifty/9fifty-3.png',
      '/shop/products/9fifty/9fifty-4.png',
      '/shop/products/9fifty/9fifty-5.png',
    ],
  },
  {
    id: 'hat-utmost',
    name: '300 Utmost Baseball Cap',
    priceCents: 5999,
    currency: 'CAD',
    description: '',
    details: [
      ['Fabric type', '80% Acrylic, 20% Wool'],
      ['Closure type', 'Buckle'],
    ],
    variants: [{ id: 'classic', name: 'Classic', image: '/shop/products/utmost/utmost-1.png' }],
    images: ['/shop/products/utmost/utmost-1.png'],
  },
];

export function variantKey(productId, variantId) {
  return `${productId}:${variantId}`;
}

export function buildCartLineItems(cart) {
  return SHOP_PRODUCTS.flatMap((product) => product.variants.flatMap((variant) => {
    const quantity = Number(cart[variantKey(product.id, variant.id)] || 0);
    if (!Number.isInteger(quantity) || quantity <= 0) {
      return [];
    }

    return [{
      variantId: variantKey(product.id, variant.id),
      productId: product.id,
      name: product.name,
      variantName: variant.name,
      unitAmount: product.priceCents,
      quantity,
    }];
  }));
}

export function getCartTotal(cart) {
  return buildCartLineItems(cart).reduce((total, item) => total + item.unitAmount * item.quantity, 0);
}

export function formatShopPrice(cents) {
  return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100);
}
